module.exports = "<div class=\"c-container sim-page sim-page--with-padding\"> <div class=\"sim-page__title sim-page-title\">Панель управления</div> <ul class=list-group> <li class=list-group-item> <a href=\"\" ng-click=$ctrl.openOrganizationInfo()>Информация по организации</a> </li> <li class=list-group-item> <a href=/clients>Клиенты</a> </li> <li class=list-group-item> <a href=/users>Пользователи</a> </li> <li class=list-group-item> <a href=\"\" ng-click=$ctrl.sendInvite()>Отправить приглашение</a> </li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/modules/components/customer-control/customer-control.html
// module id = g9fW
// module chunks = 1